//Global External Imports
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, Fragment } from "react";
import {
  TextField,
  Button,
  Grid,
  Box,
  MenuItem,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Checkbox,
  Toolbar,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import { SearchTextField } from "../lib";
import PrintIcon from "@mui/icons-material/Print";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
//Global Internal Imports
import apiRequest from "../../functions/api";
import { useMessage } from "../../context/message-context";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Page from "../shared/components/PageComponent";
import { FullPageSpinner } from "../lib";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import openFile from "../shared/functions/download";
import DynamicTable from "../shared/components/DynamicTableComponent";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import CancelIcon from "@mui/icons-material/Cancel";
//Child Imports
function FormularAdmin(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { client, accessToken, admin } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const [formulare, setFormulare] = useState([]);
  const [allcheck, setAllcheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(0);
  const [ansicht, setAnsicht] = useState(true);
  const [spalten, setSpalten] = useState({});
  const [lohnarten, setLohnarten] = useState([]);
  const [months, setMonths] = useState([]);
  const [zr, setZr] = useState(0);
  const [zeilen, setZeilen] = useState([]);
  const [freigabe, setFreigabe] = useState(0);
  const [kommentarDialog, setKommentarDialog] = useState(false);
  const [kommentar, setKommentar] = useState("");
  const [search, setSearch] = useState("");
  //PVX Kommunikation
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: admin ? "FORMAD" : "FORMAM",
      statement: "UEBERSICHT",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postUebersicht(r));
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    FilterZeilen(lohnarten, months);
  }, [zr]);
  function postUebersicht(response) {
    setIsLoading(false);
    setKommentar("");
    if (response.status === 200) {
      if (response.data.formulare) setFormulare(response.data.formulare);
      setFreigabe(response.data.freigabe);
      if (response.data.spalten) setSpalten(response.data.spalten);
      if (response.data.lohnarten) setLohnarten(response.data.lohnarten);
      if (response.data.months) setMonths(response.data.months);
      FilterZeilen(response.data.lohnarten || [], response.data.months || []);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  //Standardfunktionen
  if (isLoading) {
    return <LoadingComponent path={props.location} />;
  }
  function CheckAll(value) {
    var tmpliste = [];
    tmpliste = [...formulare];
    tmpliste.forEach((item, index) => {
      if (!value || !search || (item.pnr + item.name + item.vorname + item.formular).toLowerCase().includes(search.toLowerCase())) {
        tmpliste[index].checked = value ? "1" : "0";
      }
    });
    setFormulare(tmpliste);
  }
  function Druck(key) {
    setLoading(true);
    const payload = {
      mandant: client,
      program: admin ? "FORMAD" : "FORMAM",
      statement: "DRUCK",
      key: key,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, { headers: headers, responseType: "blob" })
      .then((response) => {
        var fileName = "Datei" + ".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  function Export() {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "FORMAD",
      statement: "EXPORT",
      formulare: formulare,
      flen: formulare ? formulare.length : 0,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postUebersicht(r));
  }
  function onChange(value, key) {
    var index = formulare.findIndex((p) => p.key === key);
    var tmpliste = [];
    tmpliste = [...formulare];
    tmpliste[index].checked = value ? "1" : "0";
    setFormulare(tmpliste);
    setAllcheck(false);
  }
  function FilterZeilen(tmpliste, monate) {
    var newliste = [];
    monate &&
      monate[zr] &&
      tmpliste &&
      tmpliste.length > 0 &&
      tmpliste
        .filter((item, index) => {
          if (monate[zr].key === "ALLE") return true;
          if (monate[zr].key === "OFFEN" && item.OFFEN === "J") return true;
          if (monate[zr].key === item.ZRKEY) return true;
          return false;
        })
        .forEach((item2, index2) => {
          newliste.push(item2);
        });
    setZeilen(newliste);
  }
  function Offen() {
    setIsLoading(true);
    setKommentarDialog(false);
    const payload = {
      mandant: client,
      program: admin ? "FORMAD" : "FORMAM",
      statement: "OFFEN",
      formulare: formulare,
      grund: kommentar,
      flen: formulare ? formulare.length : 0,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postUebersicht(r));
  }
  function Excel() {
    setLoading(true);
    const payload = {
      mandant: client,
      program: admin ? "FORMAD" : "FORMAM",
      statement: "EXCEL",
      zeilen: zeilen,
      spalten: spalten,
      zr: months[zr].bez,
      splen: spalten.length,
      zlen: zeilen.length,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, { headers: headers, responseType: "blob" })
      .then((response) => {
        var fileName = "Lohnarten_" + months[zr].bez + ".xlsx";
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  function UebExcel() {
    setLoading(true);
    const payload = {
      mandant: client,
      program: admin ? "FORMAD" : "FORMAM",
      statement: "UEBEXCEL",
      formulare: formulare,
      filter: filter,
      flen: formulare.length,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, { headers: headers, responseType: "blob" })
      .then((response) => {
        var fileName = "Formulare.xlsx";
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }

  function handleSearch(e) {
    setSearch(e.target.value);
    setAllcheck(false);
  }

  //Renderfunktionen
  return (
    <Fragment>
      <Page>
        <Grid container justifyContent="center" spacing={1}>
          <Grid item xs={12}>
            <Box P={2}>
              <Typography>{ansicht === true ? t("Übersicht Formulare") : ansicht === false ? t("Übersicht übernommene Lohnarten") : t("")}</Typography>
            </Box>
            <hr align="center" width="100%" height="2px" />
          </Grid>
          {ansicht === true && (
            <Fragment>
              {lohnarten && lohnarten.length > 0 && admin && (
                <Grid item xs={12} md={7} lg={4}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={8} md={6}>
                      <Box p={1}>
                        <Button variant="outlined" color="primary" onClick={() => setAnsicht(!ansicht)} fullWidth>
                          {ansicht === true ? t("Lohnartenübersicht") : t("Formularübersicht")}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} md={6} lg={4}>
                <Box px={1}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    label={t("Filter")}
                    select
                    value={filter}
                    color="primary"
                    onChange={(event) => setFilter(event.target.value)}
                  >
                    <MenuItem key={0} value={0}>
                      {"Genehmigte anzeigen"}
                    </MenuItem>
                    <MenuItem key={1} value={1}>
                      {"Offene anzeigen"}
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                      {"Exportierte anzeigen"}
                    </MenuItem>
                    <MenuItem key={3} value={3}>
                      {"Alle anzeigen"}
                    </MenuItem>
                  </TextField>
                </Box>
              </Grid>
              {lohnarten && lohnarten.length > 0 && admin && (
                <Grid item xs={12} md={0} lg={4}>
                  <Box p={1}></Box>
                </Grid>
              )}
              <Grid item xs={12}>
                <Toolbar>
                  <form style={{ flexGrow: 1 }}>
                    <SearchTextField
                      size="small"
                      fullWidth
                      label={t("Suche")}
                      id="search"
                      variant="outlined"
                      value={search}
                      inputProps={{
                        autoCapitalize: "off",
                        autoCorrect: "off",
                        spellCheck: "false",
                        autoComplete: "off",
                      }}
                      onChange={(e) => {
                        handleSearch(e);
                      }}
                    />
                  </form>
                </Toolbar>
              </Grid>

              <Grid item xs={12}>
                <Box p={1}>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <Checkbox
                              checked={allcheck}
                              onChange={(e) => {
                                setAllcheck(e.target.checked);
                                CheckAll(e.target.checked);
                              }}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>{t("Pnr")}</TableCell>
                          <TableCell>{t("Name")}</TableCell>
                          <TableCell>{t("Formular")}</TableCell>
                          <TableCell>{t("Von")}</TableCell>
                          <TableCell>{t("Bis")}</TableCell>
                          <TableCell>{t("Status")}</TableCell>
                          <TableCell>{t("gestellt am")}</TableCell>
                          <TableCell>{t("zuletzt bearb. von")}</TableCell>
                          <TableCell>{t("PDF Druck")}</TableCell>
                          <TableCell>{t("Exportiert")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {formulare &&
                          formulare.length > 0 &&
                          formulare
                            .filter((item, index) => {
                              if (search && (item.pnr + item.name + item.vorname + item.formular).toLowerCase().includes(search.toLowerCase()) === false)
                                return false;
                              if (filter === 3) return true;
                              if (filter === 0 && item.status !== "G") return false;
                              if (filter === 1 && (item.status === "G" || item.status === "X")) return false;
                              if (filter === 2 && item.status !== "X") return false;
                              return true;
                            })
                            .map((item, index) => {
                              return (
                                <TableRow>
                                  <TableCell>
                                    {item.status === "G" && (
                                      <Checkbox checked={item.checked === "1"} onChange={(e) => onChange(e.target.checked, item.key)} size="small" />
                                    )}
                                  </TableCell>
                                  <TableCell>{item.pnr}</TableCell>
                                  <TableCell>{item.name + ", " + item.vorname}</TableCell>
                                  <TableCell>{item.formular}</TableCell>
                                  <TableCell>{item.vdat}</TableCell>
                                  <TableCell>{item.bdat}</TableCell>
                                  <TableCell>{item.statustext}</TableCell>
                                  <TableCell>{item.erstellt}</TableCell>
                                  <TableCell>{item.bvon}</TableCell>
                                  <TableCell>
                                    <IconButton onClick={() => Druck(item.dmskey)}>
                                      <PrintIcon />
                                    </IconButton>
                                  </TableCell>
                                  <TableCell>
                                    <IconButton disabled>{item.status === "X" ? <DoneIcon color="primary" /> : <ClearIcon />}</IconButton>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>
              {(admin || freigabe === "1") && (
                <Grid item xs={12} md={6} lg={4}>
                  <Box p={1}>
                    <Button variant="outlined" color="primary" onClick={() => Export()} fullWidth>
                      {t("Auswahl exportieren")}
                    </Button>
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} md={6} lg={4}>
                <Box p={1}>
                  <Button variant="outlined" color="primary" onClick={() => setKommentarDialog(true)} fullWidth>
                    {t("Formulare auf offen setzen")}
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Box p={1}>
                  <Button variant="outlined" color="primary" onClick={() => UebExcel()} fullWidth>
                    {t("In Excel")}
                  </Button>
                </Box>
              </Grid>
            </Fragment>
          )}
          {ansicht === false && (
            <Fragment>
              {lohnarten && lohnarten.length > 0 && (
                <Grid item xs={12} md={7} lg={4}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={8} md={6}>
                      <Box p={1}>
                        <Button variant="outlined" color="primary" onClick={() => setAnsicht(!ansicht)} fullWidth>
                          {ansicht === true ? t("Lohnartenübersicht") : t("Formularübersicht")}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="zeitraum"
                  label={t("Zeitraum")}
                  select
                  size="small"
                  fullWidth
                  value={zr}
                  //onChange={(e) => {setZeitraumIndex(e.target.value)}}
                  onChange={(e) => setZr(e.target.value)}
                  variant="outlined"
                >
                  {months &&
                    months.map((item, index) => (
                      <MenuItem key={index} value={index}>
                        {item.bez}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              {lohnarten && lohnarten.length > 0 && (
                <Grid item xs={12} md={0} lg={4}>
                  <Box p={1}></Box>
                </Grid>
              )}
              <Grid item xs={12} md={10}>
                <Box p={2}>
                  <DynamicTable
                    zeilen={zeilen}
                    spalten={spalten}
                    leertext={"keine Lohnarten gefunden"}
                    hoehe={700}
                    minbreite={500}
                    options={""}
                    size={"small"}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Box p={1}>
                  <Button variant="outlined" color="primary" onClick={() => Excel()} fullWidth>
                    {t("In Excel")}
                  </Button>
                </Box>
              </Grid>
            </Fragment>
          )}
        </Grid>
      </Page>
      {loading && <FullPageSpinner />}

      <ResponsiveDialog
        title={"Formulare auf offen setzen"}
        open={kommentarDialog}
        setOpen={(o) => setKommentarDialog(false)}
        actionButton={
          <>
            <Box pl={1}>
              <Box pl={1}>
                <Button color="primary" variant="text" onClick={() => setKommentarDialog(false)}>
                  {t("Abbrechen")}
                </Button>{" "}
                <Button color="primary" variant="contained" onClick={() => Offen()}>
                  {t("auf Offen setzen")}
                </Button>
              </Box>
            </Box>
          </>
        }
      >
        <TextField
          sx={{ mt: 2 }}
          inputProps={{
            maxLength: 195,
          }}
          label={t("Kommentar")}
          value={kommentar}
          onChange={(e) => setKommentar(e.target.value)}
          autoFocus
        ></TextField>
      </ResponsiveDialog>
    </Fragment>
  );
}
export default FormularAdmin;
